import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = {
  Company: [
    { label: 'About Us',       to: '/about' },
    { label: 'Contact Us',     to: '/contact' },
    { label: 'Our Services',   to: '#' },
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms & Conditions', to: '/terms-of-service' },
  ],
  'For Job Seekers': [
    { label: 'Browse Jobs',      to: '/job-list' },
    { label: 'Job Categories',   to: '/category' },
    { label: 'Create Profile',   to: '/login' },
    { label: 'Job Alerts',       to: '/job-alerts' },
    { label: 'Career Advice',    to: '/career-advice' },
  ],
  'For Employers': [
    { label: 'Post a Job',       to: '/post-job' },
    { label: 'Browse Candidates',to: '/browse-candidates' },
    { label: 'Pricing Plans', to: '/pricing' },
    { label: 'Recruiter Login',  to: '/login' },
    { label: 'Hiring Solutions', to: '/hiring-solutions' },
  ],
};

const socials = [
  { icon: 'fab fa-linkedin-in', href: '#', label: 'LinkedIn' },
  { icon: 'fab fa-twitter',     href: '#', label: 'Twitter' },
  { icon: 'fab fa-facebook-f',  href: '#', label: 'Facebook' },
  { icon: 'fab fa-instagram',   href: '#', label: 'Instagram' },
];

const stats = [
  { num: '50K+',  label: 'Jobs Posted' },
  { num: '120K+', label: 'Job Seekers' },
  { num: '8K+',   label: 'Companies' },
  { num: '35K+',  label: 'Hired' },
];

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert(`Subscribed with ${email}`);
    setEmail('');
  };

  return (
    <footer className="pro-footer">

      {/* ── Main Footer ── */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">

            {/* Brand Column */}
            <div className="footer-brand-col">
              <Link to="/" className="footer-logo">
                <div className="footer-logo-icon">
                  <img
                src="/justhiringlogo.png"
                alt="JustHiring24"
                style={{
                  height: 60,
                  width: "auto",
                  objectFit: "contain",
                  borderRadius: "50%",
                }}/>
                </div>
                <span className="footer-logo-text">
                  <span>Just</span><span className="accent">Hiring</span>
                  <span className="accent">24</span>
                </span>
              </Link>
              <p className="footer-brand-desc">
                Connecting ambitious professionals with world-class companies. Your dream job is just one click away.
              </p>
              <div className="footer-contact-list">
                <a href="tel:+91 97180 94931" className="footer-contact-item">
                  <div className="footer-contact-icon"><i className="fa fa-phone-alt"></i></div>
                  <span>+91 97180 94931</span>
                </a>
                <a href="mailto:onexverabusinesssolutions@gmail.com" className="footer-contact-item">
                  <div className="footer-contact-icon"><i className="fa fa-envelope"></i></div>
                  <span>onexverabusinesssolutions@gmail.com</span>
                </a>
                <a href="https://maps.google.com/?q=D-184+Sector-63+Noida+UP+201301" target="_blank" rel="noreferrer" className="footer-contact-item">
                  <div className="footer-contact-icon"><i className="fa fa-map-marker-alt"></i></div>
                  <span>D-184, Sector-63, Noida, UP - 201301</span>
                </a>
              </div>
              <div className="footer-socials">
                {socials.map((s, i) => (
                  <a key={i} href={s.href} className="footer-social-btn" aria-label={s.label}>
                    <i className={s.icon}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Links Columns */}
            {Object.entries(footerLinks).map(([title, links]) => (
              <div className="footer-links-col" key={title}>
                <h6 className="footer-col-title">{title}</h6>
                <ul className="footer-links-list">
                  {links.map((link, i) => (
                    <li key={i}>
                      <Link to={link.to} className="footer-link">
                        <i className="fa fa-chevron-right"></i>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Newsletter Column */}
            <div className="footer-newsletter-col">
              <h6 className="footer-col-title">Stay Updated</h6>
              <p className="footer-newsletter-desc">
                Get the latest job listings and career tips delivered straight to your inbox.
              </p>
              <form onSubmit={handleSubscribe} className="footer-newsletter-form">
                <div className="footer-input-wrap">
                  <i className="fa fa-envelope"></i>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="footer-subscribe-btn">
                  Subscribe <i className="fa fa-arrow-right ms-2"></i>
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <div className="footer-bottom-left">
              <p className="footer-copyright">
                © {new Date().getFullYear()} Onexvora Business Solutions. All rights reserved.
              </p>
              <div className="footer-made-with">
                <span>Made with</span>
                <i className="fa fa-heart footer-heart"></i>
                <span>by Onexvora Team</span>
              </div>
            </div>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/refund-policy">Refund Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}


